"use client";

import { Search, ShieldCheck, Download } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Search",
  description: "Enter your accident details including location, date, and optional identifiers like Case ID or VIN.",
  icon: Search
}, {
  title: "Verify",
  description: "Our system securely cross-references your information with nationwide accident report databases.",
  icon: ShieldCheck
}, {
  title: "Download",
  description: "Instantly access and download your official accident report for your records or insurance claims.",
  icon: Download
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="how-it-works" className="bg-background">
      <div className="bg-muted/30 py-20">
        <div className="container mx-auto px-6 md:px-12 max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              How It Works
            </h2>
            <p className="text-lg text-foreground/70 max-w-2xl mx-auto">
              Retrieve your accident report in three simple, secure steps.
            </p>
          </div>
          
          <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
            {}
            <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-[2px] bg-border/40 z-0" />

            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className={`flex flex-col items-center text-center relative z-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: `${i * 200}ms`
            }}>
                  <div className="w-20 h-20 rounded-full bg-accent flex items-center justify-center mb-6 shadow-sm">
                    <Icon className="w-10 h-10 text-primary" />
                  </div>
                  <h3 className="text-2xl font-bold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-base text-foreground/70 leading-relaxed max-w-sm">
                    {step.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}